// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"176":"projects","443":"about"}[chunkId] + "." + {"176":"482f990c","443":"753c2536"}[chunkId] + ".js";
};